import React from 'react';

class MapRenderBlock extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (<div id="reactiveMap" style={this.props.styles}>
    </div>);
  }
}

export default MapRenderBlock;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/block/mapRenderBlock.js
 **/